import { ECountry } from '@portals/help-center-core';

export const getCurrentRegion = (country: string | Array<string>): ECountry => {
  if (typeof country === 'string') {
    if (Object.values(ECountry).includes(country as ECountry)) {
      return country as ECountry;
    }
  }
  if (Array.isArray(country) && country.length > 0) {
    const foundCountry = country.find((countryValue) =>
      Object.values(ECountry).includes(countryValue as ECountry),
    );
    if (foundCountry) return foundCountry as ECountry;
  }

  return ECountry.RUSSIA;
};
